var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wp-logo",class:{ 'wp-logo_fullwidth': _vm.fullWidth },on:{"click":_vm.goToMain}},[_c('img',{staticClass:"wp-logo__logo",attrs:{"src":require("@/assets/logo-text.svg"),"alt":"","height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }